module.exports = __webpack_public_path__ + "fonts/museo-sans-300-webfont.9d7d6b2.woff2";